import { useState } from 'react';
import RichText from 'components/rich-text';
import styles from './styles/audio-player.module.scss';
import UpChevron from 'assets/icons/chevron-up.svg';
import { useTranslations } from 'next-intl';
import type { PortableTextBlock } from '@portabletext/types';

const Transcript = ({ transcript, transcriptDefaultClosed }: IProps) => {
	const hasTranscript = !!transcript?.length;
	const [transcriptIsOpen, setTranscriptIsOpen] = useState(
		!transcriptDefaultClosed,
	);

	const t = useTranslations('audio');

	const handleTranscriptToggle = (e) => {
		e.preventDefault();
		setTranscriptIsOpen(!transcriptIsOpen);
	};

	return (
		<div>
			<div
				className={`${styles.transcriptSection} ${transcriptIsOpen ? styles.transcriptIsOpen : ''}`}
			>
				<button
					className={styles.transcriptToggle}
					onClick={handleTranscriptToggle}
					style={{ background: 'none', border: 0, color: 'currentColor' }}
				>
					<span className={styles.transcriptToggleIcon}>
						<UpChevron />
					</span>
					<span className={styles.transcriptToggleText}>
						{transcriptIsOpen ? t('hideTranscript') : t('viewTranscript')}
					</span>
				</button>

				<div className={styles.transcriptWrapper}>
					<div className={styles.transcript}>
						{hasTranscript ? (
							<RichText value={transcript} />
						) : (
							t('transcriptFallBack')
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

interface IProps {
	transcript: PortableTextBlock[] | string;
	transcriptDefaultClosed?: boolean;
}

export default Transcript;
